export class QuantityUpdater {
  constructor(form) {
    this.form = form;
    this.srcInputQuantity = form.querySelector('.js-input-counter');

    // watch change on quantity input
    this.form.addEventListener('USER_QUANTITY_UPDATED', () => {
      this.updateFormQuantity();
    });
  }

  /**
   * updateCapacity : update the capacity when quantity change
   */
  updateFormQuantity() {
    try {
      this.dstInputQuantity = document.querySelector(`#${this.form.dataset.linkedCartForm} input[name=quantity]`);
      this.dstInputQuantity.value = this.srcInputQuantity.value;
    } catch (error) {
      console.error('Error on updateQuantity', error);
    }
  }
}